import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as commonActions from '../../common/redux/actions';
import CustomLoader from '../../common/CustomLoader';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

export class VersionTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleDelete = (versionUuid) => {
    const { projectId, actions } = this.props;
    const preConfirm = () => {
      actions.deleteProjectVersion({ projectId, uuid: versionUuid }).then((res) => {
        actions.loadProjectVersion({ projectId });
      });
    };
    showAlert(
      'It will delete everything associted with this version.',
      preConfirm,
      'Yes, delete it!',
    );
  };

  checkDeploymentStatus = (cVersion) => {
    const { projectDetail, version } = this.props;
    if (!projectDetail) {
      return '-';
    }
    console.log('version checkDeploymentStatus', version, cVersion);
    const { pAlphaVersion, pBetaVersion, publishVersion } = projectDetail;
    if (+cVersion === publishVersion) {
      return 'Published at Production';
    } else if (+cVersion === pBetaVersion) {
      return 'Published at Sandbox';
    } else if (+cVersion === pAlphaVersion) {
      return 'Published at Pre-Prod';
    } else if (+cVersion === +version) {
      return 'Currently Opened to delete switch version';
    } else {
      return '-';
    }
  };

  showProjectVersion = (index, version) => {
    const message = this.checkDeploymentStatus(version.currentVersion);
    const { deleteFlag, isReadOnly } = this.props;
    return (
      <tr key={version.uuid}>
        <td>{index + 1}</td>
        <td>{version.sourceVersion}</td>
        <td>{version.currentVersion}</td>
        <td>{version.user ? version.user.username : ''}</td>
        <td>{version.user ? version.user.name : ''}</td>
        <td>{convertTimeStampToDate(version.createdAt)}</td>
        <td>
          {message === '-' ? (
            <>
              <button
                type="button"
                className="btn btn-xs btn-theme-delete"
                style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                title={isReadOnly ? 'Read-Only Mode' : 'Delete'}
                onClick={() =>
                  deleteFlag && !isReadOnly ? this.handleDelete(version.currentVersion) : undefined
                }
                disabled={isReadOnly}
              >
                <i className="wb webconnect-trash-solid"></i>

                {deleteFlag ? null : (
                  <>
                    &nbsp;
                    <TooltipInfo
                      title={description}
                      headerText={`Permission Disabled!`}
                      showHeader={true}
                      showArrow={true}
                    />
                  </>
                )}
              </button>
            </>
          ) : (
            <p>{message}</p>
          )}
        </td>
      </tr>
    );
  };

  checkAndShowProjectVersion = () => {
    const { versions } = this.props.common;
    if (!versions || versions.length === 0) {
      return 'No Version Found';
    }
    return (
      <table className="table table-border table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Source Version</th>
            <th>Current Version</th>
            <th>Creator Email</th>
            <th>Creator Name</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>{versions.map((version, index) => this.showProjectVersion(index, version))}</tbody>
      </table>
    );
  };

  render() {
    const { versions, loadProjectVersionPending, deleteProjectVersionPending } =
      this.props.appSetting;

    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <ParentCardNoCol bgColor="drapcode-violet" icon="version" title="Project Version">
            {loadProjectVersionPending || deleteProjectVersionPending ? (
              <CustomLoader loading={loadProjectVersionPending || deleteProjectVersionPending} />
            ) : (
              this.checkAndShowProjectVersion()
            )}
            {/* This feature is under maintenance... */}
          </ParentCardNoCol>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionTab);
